import { RedirectToTasks } from "@clerk/react";
import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";

import { logoColorUrl, logoNegativeUrl } from "@/brand";
import { rememberRedirect } from "@/lib/auth-helpers";

import { AuthFooter } from "./auth-footer";

export const AuthLayout = () => {
  const location = useLocation();
  const skipTasks = location.pathname.startsWith("/signup");

  useEffect(() => {
    rememberRedirect();
  }, []);

  return (
    <div className="flex min-h-dvh flex-col bg-white min-[1040px]:flex-row">
      {skipTasks ? null : <RedirectToTasks />}
      <aside className="hidden min-h-[360px] flex-col justify-between gap-16 bg-navy-900 p-[clamp(24px,4vw,56px)] text-navy-100 min-[1040px]:flex min-[1040px]:flex-[1_1_560px]">
        {/* biome-ignore lint/performance/noImgElement: this Vite app has no image optimizer */}
        <img
          alt="Anomalos"
          className="h-[22px] w-auto self-start"
          height={22}
          src={logoNegativeUrl}
          width={132}
        />
        <div className="flex flex-col gap-6">
          <div aria-hidden className="h-2 w-16 bg-coral-500" />
          <p className="m-0 font-bold text-[clamp(88px,11vw,184px)] text-white leading-[0.85] tracking-[-0.055em]">
            Studio
          </p>
          <p className="m-0 max-w-[420px] text-base text-navy-300 leading-[1.55]">
            The production workspace for Anomalos and its partners.
          </p>
        </div>
      </aside>
      <main className="flex min-h-dvh flex-1 flex-col gap-12 px-[clamp(24px,5vw,64px)] pt-[clamp(24px,4vw,56px)] pb-8 min-[1040px]:flex-[1_1_480px]">
        {/* biome-ignore lint/performance/noImgElement: this Vite app has no image optimizer */}
        <img
          alt="Anomalos"
          className="h-[22px] w-auto self-start min-[1040px]:hidden"
          height={22}
          src={logoColorUrl}
          width={132}
        />
        <div className="flex flex-1 items-center justify-center">
          <div className="w-full max-w-[400px]">
            <Outlet />
          </div>
        </div>
        <AuthFooter />
      </main>
    </div>
  );
};
